import React, { useState } from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    TableContainer,
    IconButton,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { useStyles, StyledTableCell } from "../../adminStyles";

const VendorTable = props => {
    const [del, setDel] = useState({ open: false, id: 0 });
    const { tableRoot, tableContainer, sortLabel } = useStyles();

    const {
        columns,
        rows,
        sortArray,
        orderAscending,
        orderBy,
        asc,
        searchTerm,
    } = props;

    const handleClose = () => setDel({ open: false, id: 0 });

    const handleOk = () => {
        const vid = del.id;
        const status = del.status;
        setDel({ open: false, id: 0 });
        props.deleteVendor(status, vid);
    };

    const renderStyledTableCell = () =>
        columns.map(column =>
            column.id === "vendorName" ||
            column.id === "vendorEmail" ||
            column.id === "website" ||
            column.id === "contactPName" ? (
                <StyledTableCell
                    key={column.id}
                    align={"center"}
                    padding={column.disablePadding ? "none" : "default"}
                    sortDirection={
                        orderBy === column.id ? orderAscending : false
                    }
                >
                    <TableSortLabel
                        active={orderBy === column.id}
                        direction={asc}
                        onClick={sortArray(rows, column.id)}
                        className={sortLabel}
                    >
                        {column.label}
                    </TableSortLabel>
                </StyledTableCell>
            ) : (
                <StyledTableCell
                    key={column.id}
                    align={"center"}
                    padding={column.disablePadding ? "none" : "default"}
                >
                    {column.label}
                </StyledTableCell>
            )
        );

    const renderTableBody = () =>
        rows
            .filter(
                row =>
                    (row.vendorName || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    (row.vendorEmail || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    (row.website || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    (row.contactPName || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
            )

            .map((row, i) => {
                return (
                    <TableRow tabIndex={-1} key={row.code} size="small">
                        {columns.map(column => {
                            const value = row[column.id];

                            return (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    width={column.mainWidth}
                                >
                                    {column.id === "vendorName" ? value : null}
                                    {column.id === "vendorEmail" ? value : null}
                                    {column.id === "website" ? value : null}
                                    {column.id === "contactPName"
                                        ? value
                                        : null}
                                    {column.id === "action" ? (
                                        <>
                                            <IconButton
                                                color="primary"
                                                onClick={() => {
                                                    props.history.push(
                                                        `/admin/vendordetails/${row.vendorId}`
                                                    );
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            {props.activeRecords ? (
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        setDel({
                                                            open: true,
                                                            id: `${row.vendorId}`,
                                                            status: false,
                                                        });
                                                    }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            ) : null}
                                        </>
                                    ) : null}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                );
            });

    return (
        <Paper className={tableRoot}>
            <TableContainer className={tableContainer}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>{renderStyledTableCell()}</TableRow>
                    </TableHead>
                    <TableBody>{renderTableBody()}</TableBody>
                </Table>
            </TableContainer>

            <Dialog
                open={del.open}
                onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    Conformation For Delete User
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Aru you sure you want to delete the vendor?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleOk} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    );
};

export default VendorTable;
